export default __webpack_public_path__ + "static/media/WebResume3.c702bbe0.png";